export default __webpack_public_path__ + "static/media/on.cd0532d0.svg";